import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { __, _i } from "../../utils/i18n.js";
const SupportFormTermField = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                label: "",
                required: true,
                name: "terms",
                valuePropName: "checked",
                rules: [
                    {
                        required: true,
                        transform: (value)=>value || undefined,
                        type: "boolean",
                        message: __("In order to submit a support request, you must agree to this.")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    children: _i(__("I have read the {{a}}General Terms and Conditions{{/a}} and agree to them."), {
                        a: /*#__PURE__*/ _jsx("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: __("https://devowl.io/terms/")
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                label: "",
                required: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.questionType !== nextValues.questionType,
                noStyle: true,
                children: (param)=>{
                    let { getFieldValue } = param;
                    const questionType = getFieldValue("questionType");
                    return [
                        ESupportTicketQuestionType.ProblemWithLicenseOrAccount,
                        ESupportTicketQuestionType.ProblemWithProduct,
                        ESupportTicketQuestionType.FeatureRequest
                    ].indexOf(questionType) > -1 && /*#__PURE__*/ _jsx(Form.Item, {
                        name: "dpa",
                        valuePropName: "checked",
                        rules: [
                            {
                                required: true,
                                transform: (value)=>value || undefined,
                                type: "boolean",
                                message: __("In order to submit a support request, you must agree to this.")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            children: _i(__("I have read the {{a}}data processing agreement{{/a}} and agree to it as the data controller. I am aware that my personal data and other technical data must be processed in order to process my enquiry."), {
                                a: /*#__PURE__*/ _jsx("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: __("https://devowl.io/dpa-support/")
                                })
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                label: "",
                children: _i(__("Information on the processing of your personal data can be found in our {{a}}privacy policy{{/a}}."), {
                    a: /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: __("https://devowl.io/privacy-policy")
                    })
                })
            })
        ]
    });
};
export { SupportFormTermField };
